import React, { memo } from 'react'
import IcoMoon from 'react-icomoon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import iconSet from '../../icons/selection.json'
import { isString } from '../../util/string.helpers'

const BWIcon = ({
  faIconCss,
  moonIconCss,
  icon,
  size,
  iconColor,
  disabled
}) => {
  return isString(icon) ? (
    <MoonIcon
      iconSet={iconSet}
      icon={icon}
      size={size}
      customcss={moonIconCss}
      iconcolor={iconColor}
      disabled={disabled}
    />
  ) : (
    <FaIcon
      customcss={faIconCss}
      icon={icon}
      iconcolor={iconColor}
      disabled={disabled}
    />
  )
}

export default memo(BWIcon)

const FaIcon = styled(FontAwesomeIcon)`
  ${(props) => iconStyles(props)};
`

const MoonIcon = styled(IcoMoon)`
  ${(props) => iconStyles(props)};
`

const iconStyles = ({
  customcss,
  theme: { colors },
  iconcolor,
  disabled
}) => css`
  color: ${disabled ? colors.liteWhite : colors[iconcolor]};
  ${customcss && customcss};
`
